<script lang="ts">
    import { onDestroy } from "svelte";
    import { typewriter } from "../utils/animation";

    export let name = "oeken";
    export let url = "https://github.com/oeken";

    let prompt = "~$: whoami";
    let showCursor = false;
    let showName = false;

    const interval = setInterval(() => {
        showCursor = !showCursor;
    }, 800);

    onDestroy(() => clearInterval(interval));
</script>

<div class="root-container">
    {#if showName}
        <div class="command-line">
            <span
                transition:typewriter
                class="cursor-pointer"
                on:click={() => window.open(url, "_blank").focus()}
            >
                {name}</span
            >
            {#if showCursor}
                <span>&#x258A;</span>
            {/if}
        </div>
    {:else}
        <div class="command-line">
            <span class="cursor-pointer" on:click={() => (showName = true)}
                >{prompt}</span
            >
            {#if showCursor}
                <span>&#x258A;</span>
            {/if}
        </div>
    {/if}
</div>

<style lang="scss">
    .root-container {
        height: 1.25rem;
    }

    .cursor-pointer {
        cursor: pointer;
    }

    .command-line {
        font-family: monospace;
        font-size: 16px;
        color: #72f270;
        text-shadow: 0px 0px 2px #72f270;
        display: flex;
    }
</style>
